const TABLEAU_HEIGHT = import.meta.env.VITE_TABLEAU_HEIGHT ?? "100vh";
const TABLEAU_P4P_HEIGHT = import.meta.env.VITE_TABLEAU_P4P_HEIGHT ?? "100vh";

export const TABLEAU = {
  workbook: import.meta.env.VITE_TABLEAU_WORKBOOK ?? "SCOPBCDashboard_Staging",
  view: import.meta.env.VITE_TABLEAU_VIEW ?? "SCOPBCDashboard",
  height: TABLEAU_HEIGHT,
};

export const TABLEAU_P4P = {
  workbook: import.meta.env.VITE_TABLEAU_P4P_WORKBOOK ?? "P4PDashboard",
  view: import.meta.env.VITE_TABLEAU_P4P_VIEW ?? "P4P_Main",
  height: TABLEAU_P4P_HEIGHT,
};

export const TABLEAU_RS = {
  workbook: import.meta.env.VITE_TABLEAU_RS_WORKBOOK ?? import.meta.env.VITE_TABLEAU_WORKBOOK ?? "RS_Dashboard_Staging",
  view: import.meta.env.VITE_TABLEAU_RS_VIEW ?? import.meta.env.VITE_TABLEAU_VIEW ?? "PBCRSDashboard",
  height: TABLEAU_HEIGHT,
  isActive:
    String(import.meta.env.VITE_TABLEAU_RS_IS_ACTIVE).toLowerCase() === "true",
};

export const TABLEAU_SCO = {
  workbook: import.meta.env.VITE_TABLEAU_SCO_WORKBOOK ?? "SCOPBCDashboard_Staging",
  view: import.meta.env.VITE_TABLEAU_SCO_VIEW ?? "SCOPBCDashboard",
  height: TABLEAU_HEIGHT,
  isActive:
    String(import.meta.env.VITE_TABLEAU_SCO_IS_ACTIVE).toLowerCase() === "true",
};

export const TABLEAU_P4P_RS = {
  workbook: import.meta.env.VITE_TABLEAU_P4P_RS_WORKBOOK ?? "",
  view: import.meta.env.VITE_TABLEAU_P4P_RS_VIEW ?? "",
  height: TABLEAU_P4P_HEIGHT,
  isActive:
    String(import.meta.env.VITE_TABLEAU_P4P_RS_IS_ACTIVE).toLowerCase() ===
    "true",
};

export const TABLEAU_P4P_SCO = {
  workbook:
    import.meta.env.VITE_TABLEAU_P4P_SCO_WORKBOOK ??
    import.meta.env.VITE_TABLEAU_P4P_WORKBOOK ??
    "PBC-PayforPerformanceP4PDashboard_Staging",
  view:
    import.meta.env.VITE_TABLEAU_P4P_SCO_VIEW ??
    import.meta.env.VITE_TABLEAU_P4P_VIEW ??
    "P4PDashboard",
  height: TABLEAU_P4P_HEIGHT,
  isActive:
    String(import.meta.env.VITE_TABLEAU_P4P_SCO_IS_ACTIVE).toLowerCase() ===
    "true",
};